<template>
  <div class="chuchuang">
    <router-view :form="form" @onSubmit="handleSubmit" />
  </div>
</template>

<script>
import "vant/lib/index.css";
import { Dialog } from "vant";
import { submit } from "@/api/chapterMock";

export default {
  data() {
    return {
      form: {
        isAuthentication: false,
        isBond: false,
        realName: "",
        idNumber: "",
        qualificationType: "",
        idCardVid: "",
        idCardLong: false,
        idCardFront: "",
        idCardBack: "",
        bankNumber: "",
        mobile: "",
        code: "",
        haveJh: false,
        backCardNum: "",
        khh: "",
        bankAddress: "",
        khzh: "",
        bankMobile: "",
        contactsMobile: "",
        autoDeduction: true,
        wxMobile: "",
        email: "",
        haveWx: false,
      },
    };
  },
  methods: {
    handleSubmit() {
      // console.log(this.form);
      const classChapterId = localStorage.getItem("mockChapterId");
      submit({
        classChapterId,
        content: JSON.stringify(this.form),
      }).then((res) => {
        Dialog.alert({
          title: "提示",
          message: "提交完成",
        }).then(() => {
          this.$router.go(-1);
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.chuchuang {
  height: 100vh;
  background-color: #f9f9f9;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 0 !important;
  }
}
</style>